import { getGetRRMSAccountQueryKey, useGetRRMSAccount } from '@transreport/pauk-rrms-api'
import { useEffect } from 'react'

import { useAuthStore } from '@/lib/stores/auth'

export function useAccountProfile({
  enabled,
  userId,
}: {
  enabled: boolean
  userId: string | undefined
}) {
  const setCurrentUser = useAuthStore((state) => state.setCurrentUser)
  const currentUser = useAuthStore((state) => state.currentUser)

  const { data, isError, refetch } = useGetRRMSAccount({
    query: {
      // Scope the cache per authenticated user identity so that switching
      // accounts on the same device never serves a previous user's profile.
      // The enabled guard ensures this only fires when userId is defined.
      queryKey: [...getGetRRMSAccountQueryKey(), userId],
      enabled: enabled && !!userId,
      staleTime: 5 * 60_000,
    },
  })

  useEffect(() => {
    if (data) setCurrentUser(data)
  }, [data, setCurrentUser])

  return {
    isProfileReady: currentUser !== null,
    isProfileError: isError,
    refetchProfile: refetch,
  }
}
